// extracted by mini-css-extract-plugin
export default {"hostContainer":"vph5ccLKIZ","iframe":"Ymr8U4yqN5"};